import { Nullable } from '@types'

import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import RadioGroup from '@mui/material/RadioGroup'
import { SelectChangeEvent } from '@mui/material/Select'
import Typography from '@mui/material/Typography'
import { numberWithCommas } from '@shared/utils'

import { SelectFormControlLabel, SelectLabelText, SelectLabelWrapper, SelectRadio } from '../../index.styles'
import { createPendoIdFromLabel } from './utils'

interface Props {
  value: Nullable<string | number>
  label?: string
  options: { label: string; total?: string; value: Nullable<string | number>; forceChecked?: boolean; id?: string }[]
  onChange: (value: string) => void
  filterName?: string
  profileType?: string
}

const SingleSelect = (props: Props) => {
  const { value: selectedValue, label, profileType = '', options, filterName = '', onChange } = props

  const handleChange = (e: SelectChangeEvent) => {
    const target = e.target as HTMLInputElement

    onChange(target.value)
  }

  const forceSelectedItem = { value: null } // options.find(i => i.forceChecked)

  return (
    <FormControl fullWidth data-testid="single_select">
      {label && <FormLabel>{label}</FormLabel>}
      <RadioGroup
        name={label}
        value={selectedValue === null ? null : forceSelectedItem?.value || selectedValue}
        onChange={handleChange}
        defaultChecked
      >
        {options.map(i => (
          <SelectFormControlLabel
            key={i.value}
            value={i.value}
            id={createPendoIdFromLabel({ profileType, filterName, filterValue: i.value ?? 'none' })}
            control={<SelectRadio disableRipple inputProps={{ id: i.id }} />}
            label={
              <SelectLabelWrapper>
                <SelectLabelText variant="body2" data-testid="single_select_label">
                  {i.label}
                </SelectLabelText>
                {!!i.total && (
                  <Typography variant="body2" data-testid="single_select_total">
                    ({numberWithCommas(i.total)})
                  </Typography>
                )}
              </SelectLabelWrapper>
            }
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}

export default SingleSelect
